import { paths } from '../paths';

export default function buildSsoReturnUrl(bookingId, referrerType) {
    const queryString = referrerType ? `?referrerType=${referrerType}` : '';
    return encodeURI(`${paths.reviewAndBookPath}/${bookingId}${queryString}`);
}
